<div class="d-flex align-items-center justify-content-center my-5">
  <div class="d-flex flex-column flex-md-row">
    <button
      type="button"
      routerLink="/info_aifa"
      class="d-flex flex-row align-items-center justify-content-between shadow border-0 rounded button-custom me-4 mb-3 p-5"
    >
      <div class="d-flex flex-row">
        <img
          class="img-icon"
          src="assets/icons/Cose-aifa.svg"
          alt=""
          aria-hidden="true"
        />
      </div>
      <h3
        class="text-primary mt-3"
        i18n="
          CTA search page|Cosa è AIFA Medicinali
          @@search-page.section-button.cosa-e-aifa-button-text"
        aria-label="Cosa è AIFA Medicinali"
      >
        Cosa è AIFA Medicinali
      </h3>
      <img
        class="img-icon"
        src="assets/icons/arrow-right-solid.svg"
        alt=""
        aria-hidden="true"
      />
    </button>

    <button
      type="button"
      routerLink="/glossario"
      class="d-flex flex-row align-items-center justify-content-between shadow border-0 rounded button-custom button-custom2 p-5"
    >
      <div class="d-flex flex-row">
        <img
          class="img-icon"
          src="assets/icons/glossario.svg"
          alt=""
          aria-hidden="true"
        />
      </div>
      <h3
        class="text-primary mt-2"
        i18n="
          CTA search page| Glossario
          @@search-page.section-button.glossarion-button-text"
        aria-label="Glossario"
      >
        Glossario
      </h3>
      <img
        class="img-icon"
        src="assets/icons/arrow-right-solid.svg"
        alt=""
        aria-hidden="true"
      />
    </button>
  </div>
</div>
